import { render, staticRenderFns } from "./VsEyeMoreInfo.vue?vue&type=template&id=6065c680&scoped=true&"
import script from "./VsEyeMoreInfo.vue?vue&type=script&lang=js&"
export * from "./VsEyeMoreInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6065c680",
  null
  
)

export default component.exports